define("calendar/components/calendar/onboarding/wizards/wrapper", ["exports", "@ember/component", "@ember/template-factory", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking"], function (_exports, _component, _templateFactory, _object, _service, _component2, _tracking) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div
    {{did-insert this.onboardingWizardManager.validateSocialProfile}}
    {{did-update this.onboardingWizardManager.validateSocialProfile this.onboardingWizardManager.socialProfile}}
  >
    {{component
      this.onboardingWizardManager.componentName
      didUploadMedia=@didUploadMedia
      educationBoxChecked=this.educationBoxChecked
      showTrialOptInModal=@showTrialOptInModal
      socialProfile=this.onboardingWizardManager.socialProfile
      trackOnboardingStep=this.trackOnboardingStep
      transition=this.onboardingWizardManager.transition
    }}
  </div>
  */
  {
    "id": "RWFLTV29",
    "block": "[[[11,0],[4,[38,0],[[30,0,[\"onboardingWizardManager\",\"validateSocialProfile\"]]],null],[4,[38,1],[[30,0,[\"onboardingWizardManager\",\"validateSocialProfile\"]],[30,0,[\"onboardingWizardManager\",\"socialProfile\"]]],null],[12],[1,\"\\n  \"],[46,[30,0,[\"onboardingWizardManager\",\"componentName\"]],null,[[\"didUploadMedia\",\"educationBoxChecked\",\"showTrialOptInModal\",\"socialProfile\",\"trackOnboardingStep\",\"transition\"],[[30,1],[30,0,[\"educationBoxChecked\"]],[30,2],[30,0,[\"onboardingWizardManager\",\"socialProfile\"]],[30,0,[\"trackOnboardingStep\"]],[30,0,[\"onboardingWizardManager\",\"transition\"]]]],null],[1,\"\\n\"],[13]],[\"@didUploadMedia\",\"@showTrialOptInModal\"],false,[\"did-insert\",\"did-update\",\"component\"]]",
    "moduleName": "calendar/components/calendar/onboarding/wizards/wrapper.hbs",
    "isStrictMode": false
  });

  let WrapperComponent = (_class = class WrapperComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "onboardingWizardManager", _descriptor, this);

      _initializerDefineProperty(this, "onboarding", _descriptor2, this);

      _initializerDefineProperty(this, "educationBoxChecked", _descriptor3, this);
    }

    trackOnboardingStep(eventName) {
      this.onboarding.trackOnboardingStep(eventName);
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "onboardingWizardManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "onboarding", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "educationBoxChecked", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "trackOnboardingStep", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackOnboardingStep"), _class.prototype)), _class);
  _exports.default = WrapperComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, WrapperComponent);
});